export const LINE_COLORS = {
  EMPTY: '#d30202',
  READY_HARVEST: '#409900',
  REQUIRE_ASSESSMENT: '#aeef75',
  CATCH_SPAT: '#c5a800',
  NORMAL: '#16131b',
};

export const APP_NAME = 'Mussel App';

export const ACTIVITY_COLORS = {
  seeding: '#1976d2',
  assessment: '#8404ae',
  maintenance: '#938700',
  inventory_seed: '#6d4c41',
  harvest: '#385a24',
  danger: '#f0142f',
};

export const CROP_COLORS = {
  MUSSEL: '#005A8D',
  OYSTER: '#B8B8B8',
  SEAWEED: '#4CAF50',
};
